<template lang='pug' src='./loader.pug'></template>

<script>
import Icon from 'components/icon/icon'
export default {
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// loader.vue?108dd046